// src/data/heavyDuty.js
import Dates1 from "../assets/dateStamping/IMG-20250828-WA0013.jpg";
import Dates2 from "../assets/dateStamping/IMG-20250828-WA0014.jpg";
import Dates3 from "../assets/dateStamping/IMG-20250828-WA0015.jpg";
import Dates4 from "../assets/dateStamping/IMG-20250828-WA0016.jpg";
import Dates5 from "../assets/dateStamping/IMG-20250828-WA0017.jpg";
import Dates6 from "../assets/dateStamping/IMG-20250828-WA0018.jpg";

const DatesStampingData = [
  {
    id: 1,
    name: "Date Stamp With Plate",
    category: "Date",
    image: Dates1,
    size: "62x42 mm",
    description: "Heavy-duty date stamp with plate, ideal for large labels and documents. Metal frame ensures durability for daily use.",
  },
  {
    id: 2,
    name: "Date Stamp With Plate",
    category: "Date",
    image: Dates2,
    size: "43x28 mm",
    description: "Compact date stamp with wide impression area. Perfect for repetitive stamping with consistent results.",
  },
  {
    id: 3,
    name: "Date Stamp",
    category: "Date",
    image: Dates3,
    size: "Medium",
    description: "Medium-sized date stamp with steel-frame construction, delivering precise and clear impressions for industrial and office use.",
  },
  {
    id: 4,
    name: "Date Stamp",
    category: "Date",
    image: Dates4,
    size: "Small",
    description: "Small date stamp with integrated text layout. Suitable for fast document processing in warehouses and offices.",
  },
  {
    id: 5,
    name: "Date Stamp With Received, Paid, Faxed, Approved, Posted",
    category: "Date",
    image: Dates5,
    size: "All Sizes",
    description: "Multi-purpose heavy-duty stamp with multiple fields. Ideal for marking received, paid, faxed, approved, or posted documents clearly.",
  },
  {
    id: 6,
    name: "Date Stamp With Plate",
    category: "Date",
    image: Dates6,
    size: "39x22 mm",
    description: "Extra-small date stamp with plate, perfect for tight spaces or small labels. Durable design for long-term usage.",
  },
];

export default DatesStampingData;
